import {
  ButtonField,
  Notification,
  NotificationActions,
  NotificationContainer,
} from '@wk/components-react16';

import useToast from '@/shared/stores/toastStore';

const Toaster = () => {
  const { toasts, removeToast } = useToast();

  return (
    <NotificationContainer>
      {toasts.map((item) => {
        return (
          <Notification
            controlMode="controlled"
            isOpen={true}
            mode="toast"
            isLineClampUnset
            type={item.type}
            autoCloseTimeout={item.autoCloseTimeout || 5000}
            hasCloseButton
            heading={item.title || ''}
            onUserRequest={() => removeToast(item.id)}
            key={item.id}
          >
            <span slot="notificationContent">{item.message}</span>
            {item.actions && (
              <NotificationActions slot="notificationActions">
                {item.actions.map((action) => (
                  <ButtonField
                    mode={action.mode}
                    size={action.size}
                    key={action.label}
                  >
                    <button type="button" onClick={action.onClick}>
                      {action.label}
                    </button>
                  </ButtonField>
                ))}
              </NotificationActions>
            )}
          </Notification>
        );
      })}
    </NotificationContainer>
  );
};

export default Toaster;
